var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineChekinSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Online Check-in"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.51953 16.7014L8.03393 12.9154C8.27531 12.3123 8.6366 11.7644 9.09593 11.305L17.3999 3.0034C17.8773 2.52601 18.5248 2.25781 19.1999 2.25781C19.8751 2.25781 20.5225 2.52601 20.9999 3.0034C21.4773 3.48079 21.7455 4.12827 21.7455 4.8034C21.7455 5.47853 21.4773 6.12601 20.9999 6.6034L12.6959 14.905C12.2363 15.3646 11.6879 15.727 11.0843 15.9682L7.29953 17.4826C7.19049 17.5262 7.07104 17.5369 6.95599 17.5133C6.84094 17.4897 6.73535 17.4329 6.6523 17.3498C6.56925 17.2668 6.5124 17.1612 6.4888 17.0461C6.4652 16.9311 6.47588 16.8116 6.51953 16.7026V16.7014Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.20039 6.90156C4.20039 6.07356 4.87239 5.40156 5.70039 5.40156H12.0004C12.2391 5.40156 12.468 5.30674 12.6368 5.13796C12.8056 4.96918 12.9004 4.74026 12.9004 4.50156C12.9004 4.26287 12.8056 4.03395 12.6368 3.86517C12.468 3.69638 12.2391 3.60156 12.0004 3.60156H5.70039C4.82518 3.60156 3.98581 3.94924 3.36694 4.56811C2.74807 5.18698 2.40039 6.02635 2.40039 6.90156V18.3016C2.40039 19.1768 2.74807 20.0161 3.36694 20.635C3.98581 21.2539 4.82518 21.6016 5.70039 21.6016H17.1004C17.9756 21.6016 18.815 21.2539 19.4338 20.635C20.0527 20.0161 20.4004 19.1768 20.4004 18.3016V12.0016C20.4004 11.7629 20.3056 11.5339 20.1368 11.3652C19.968 11.1964 19.7391 11.1016 19.5004 11.1016C19.2617 11.1016 19.0328 11.1964 18.864 11.3652C18.6952 11.5339 18.6004 11.7629 18.6004 12.0016V18.3016C18.6004 19.1296 17.9284 19.8016 17.1004 19.8016H5.70039C4.87239 19.8016 4.20039 19.1296 4.20039 18.3016V6.90156Z",
    fill: "#385BF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineChekinSidebar);
export default __webpack_public_path__ + "static/media/online-chekin-sidebar.cbf75b264be77166a323aef354a15a50.svg";
export { ForwardRef as ReactComponent };